import { post } from '@web3/base-utils';
import {
  PostStakeFeeParams,
  PostStakeFeeRes,
  PostStakeParams,
  PostStakeEncodeParams,
  PostStakeEncodeRes,
  PostSaveStakeOrderParam,
  PostSaveStakeOrderRes,
  PostLpAmountParams,
  GetStakeEstimateTokenParam,
  GetStakeEstimateTokenRes,
} from '@/types/stake';
import { feeLevelMap } from '@/config/map';
import { baseApiUrl } from '@/config/api';

export const postStakeFee = (params: PostStakeFeeParams) => {
  return post<PostStakeFeeRes>(`${baseApiUrl}/v2/order/stake/fee`, {
    ...params,
    type: 'web',
    level: feeLevelMap[params.level || 'middle'],
    maxPriorityFeePerGas: 1,
    baseFee: 1,
  });
};

export const postStake = (params: PostStakeParams) => {
  return post<{ orderCode: string }>(`${baseApiUrl}/v2/order/stake`, {
    ...params,
    type: 'web',
  });
};

export const postStakeEncode = (params: PostStakeEncodeParams) => {
  return post<PostStakeEncodeRes>(`${baseApiUrl}/v3/stake/encode`, params, {
    useThirdConfig: true,
  });
};

export const postSaveStakeOrder = (params: PostSaveStakeOrderParam) => {
  return post<PostSaveStakeOrderRes>(
    `${baseApiUrl}/v3/stake/saveStakeOrder`,
    params
  );
};

export const postLpAmount = (params: PostLpAmountParams) => {
  return post<string>(`${baseApiUrl}/v2/order/lpAmount`, params);
};

export const getStakeEstimateToken = (params: GetStakeEstimateTokenParam) => {
  return post<GetStakeEstimateTokenRes>(
    `${baseApiUrl}/v3/stake/estimateLpNew`,
    params
  );
};
